import { createContext, useContext, useState, useEffect } from 'react';




const cards = {
  "stats_cards": [
    { "title": "اجمالي المبيعات (LTM)", "value": 8450000, "change": 15.2, "direction": "up", "currency": "USD", icon: "mdi:currency-usd" },
    { "title": "المستخدمين النشطين أخر 30 يوم", "value": 187342, "change": 12.1, "direction": "up", icon: "mdi:users"},   
 
       { "title": "متوسط قيمة الطلب", "value": 284, "change": 6.2, "direction": "up", icon: "mdi:cash-register" },
    { "title": "نسبة التحويل الإجمالية", "value": 5.2, "change": 0.7, "direction": "up", icon: "mdi:chart-pie" },
    { "title": "نسبة التحويل الإجمالية", "value": 5.2, "change": 0.7, "direction": "up", icon: "mdi:chart-pie" },
    { "title": "نسبة التحويل الإجمالية", "change": 0.7, "direction": "up" , icon: "mdi:chart-pie"},
    // { "title": "معدل الارتداد", "value": 31.5, "change": -4.1, "direction": "down" },  
    { "title": "CSAT (آخر 30 يوم)", "value": 4.85, "change": 0.2, "direction": "up" },
    { "title": "معدل الحذف", "value": [
      {"key":"المبيعات", "val": 500},
      {"key":"المستخدمين", "val": 200}
    ], "change": 0.2, "direction": "up" },

    { "title": "تذاكر الدعم المفتوحة", "value": 256, "change": -22, "direction": "down" },
    { "title": "متوسط سرعة التحميل (ث)", "value": 1.2, "change": 18, "direction": "up" },
     { "title": "معدل الحذف", "value": [
      {"key":"المبيعات", "val": 500},
      {"key":"المستخدمين", "val": 200}
    ], "change": 0.2, "direction": "up" },
    { "title": "متوسط سرعة التحميل (ث)", "value": 1.2, "change": 18, "direction": "up" },
  ],
  "daily_sales_6months": [
    { "month": "Jan", "sales": 680000, "users": 43120, "orders": 3120, "conversion": 4.3, "csat": 4.5 },
    { "month": "Feb", "sales": 710000, "users": 44500, "orders": 3250, "conversion": 4.4, "csat": 4.55 },
    { "month": "Mar", "sales": 755000, "users": 46780, "orders": 3410, "conversion": 4.5, "csat": 4.6 },
    { "month": "Apr", "sales": 802000, "users": 49500, "orders": 3620, "conversion": 4.7, "csat": 4.65 },
    { "month": "May", "sales": 845000, "users": 52300, "orders": 3790, "conversion": 4.9, "csat": 4.7 },
    { "month": "Jun", "sales": 890000, "users": 55800, "orders": 4010, "conversion": 5.0, "csat": 4.75 },
    { "month": "Jul", "sales": 935000, "users": 59200, "orders": 4280, "conversion": 5.1, "csat": 4.78 },
    { "month": "Aug", "sales": 978000, "users": 63400, "orders": 4560, "conversion": 5.2, "csat": 4.8 },
    { "month": "Sep", "sales": 1012000, "users": 67200, "orders": 4820, "conversion": 5.3, "csat": 4.82 },
    { "month": "Oct", "sales": 1058000, "users": 71500, "orders": 5110, "conversion": 5.4, "csat": 4.84 },
    { "month": "Nov", "sales": 1105000, "users": 76400, "orders": 5430, "conversion": 5.5, "csat": 4.86 },
    { "month": "Dec", "sales": 1180000, "users": 82100, "orders": 5870, "conversion": 5.6, "csat": 4.88 }
  ],
  "sales_by_region": [
    { "region": "Cairo", "sales": 2850000, "orders": 9860, "growth": 12.3, "top_product": "Laptop X1" },
    { "region": "Alex", "sales": 1720000, "orders": 6720, "growth": 9.1, "top_product": "Headphones Pro" },
    { "region": "Giza", "sales": 1950000, "orders": 7380, "growth": 14.2, "top_product": "Smart Watch" },
    { "region": "Delta", "sales": 1280000, "orders": 5200, "growth": 7.8, "top_product": "Power Bank" },
    { "region": "Upper Egypt", "sales": 650000, "orders": 2590, "growth": 18.5, "top_product": "Tablet" }
  ],
  "monthly_metrics": [
    { "date": "2025-11-01", "visitors": 1890 },
    { "date": "2025-11-02", "visitors": 1840 },
    { "date": "2025-11-03", "visitors": 1200 },
    { "date": "2025-11-04", "visitors": 1840 },
    { "date": "2025-11-05", "visitors": 1500 }
  ],
  "top_50_products": [
    { "rank": 1, "name": "Ultra Laptop X1", "sales": 542000, "units": 1240, "margin": 28 },
    { "rank": 2, "name": "Wireless Headphones Pro", "sales": 382000, "units": 2450, "margin": 42 }
  ],
  "traffic_sources_daily": [
    { "source": "Google Ads", "visitors": 45800, "conversions": 1820, "cost": 12500, "roi": 4.2 },
    { "source": "Facebook", "visitors": 38700, "conversions": 1450, "cost": 8700, "roi": 3.9 },
    { "source": "Organic Search", "visitors": 72400, "conversions": 2890, "cost": 0, "roi": null },
    { "source": "Email Marketing", "visitors": 15600, "conversions": 890, "cost": 1200, "roi": 5.6 },
    { "source": "Referral", "visitors": 12300, "conversions": 560, "cost": 0, "roi": null }
  ],
  "hourly_traffic_pattern": [
    { "hour": 0, "visitors": 340 }, { "hour": 1, "visitors": 210 }, { "hour": 2, "visitors": 150 },
    { "hour": 8, "visitors": 1890 }, { "hour": 12, "visitors": 3450 }, { "hour": 15, "visitors": 4200 },
    { "hour": 20, "visitors": 6120 }, { "hour": 21, "visitors": 5980 }, { "hour": 22, "visitors": 4210 }
  ],
  "device_performance": [
    { "device": "Mobile", "sessions": 124500, "bounce_rate": 38.2, "conversion": 4.6 },
    { "device": "Desktop", "sessions": 87200, "bounce_rate": 28.5, "conversion": 6.2 },
    { "device": "Tablet", "sessions": 23400, "bounce_rate": 32.1, "conversion": 5.1 }
  ]
}

const HomeContext = createContext();

const HomeProvider = ({ children }) => {

    const [loading, setLoading] = useState(true);
    const [statsCards, setStatsCards] = useState(cards.stats_cards);
    const [monthlyMetrics, setMonthlyMetrics] = useState(cards.monthly_metrics);
    const [salesByRegion, setSalesByRegion] = useState(cards.sales_by_region);
    const [dailySales6months, setDailySales6months] = useState(cards.daily_sales_6months);
    const [top50Products, setTop50Products] = useState(cards.top_50_products);
    const [trafficSourcesDaily, setTrafficSourcesDaily] = useState(cards.traffic_sources_daily);
    const [hourlyTrafficPattern, setHourlyTrafficPattern] = useState(cards.hourly_traffic_pattern);
    const [devicePerformance, setDevicePerformance] = useState(cards.device_performance);




    const value ={
        loading,
        statsCards,
        monthlyMetrics,
        salesByRegion,
        dailySales6months,
        top50Products,
        trafficSourcesDaily,
        hourlyTrafficPattern,
        devicePerformance
    }

    return (
        <HomeContext.Provider value={value}>
            {children}
        </HomeContext.Provider>
    );
};

export default HomeProvider;

export const useHome = () => {
  const context = useContext(HomeContext);
  if (!context) {
    throw new Error('useHome must be used within HomeProvider');
  }
  return context;
};
